<template>
  <div id="app" class="app" :class="{'has-footer': hasNav }">
    <div class="app-body">
      <transition :name="directionClass">
        <keep-alive>
          <router-view :key="pagekey" />
        </keep-alive>
      </transition>
      <!-- <transition :name="directionClass">
        <template v-if="1||this.$route.meta.isKeepAlive">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </template>
        <template v-else>
          <router-view v-if="!this.$route.meta.isKeepAlive"></router-view>
        </template>
      </transition>-->
    </div>
    <tab-bar class="app-tab" v-if="hasNav"></tab-bar>
  </div>
</template>

<script>
import tabBar from "@/views/common/tabBar";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      keepList: [
        "home",
        "addNewServiceAddress",
        "orderConfirm",
        "pay",
        "serviceDetail",
        "orderDetail"
      ],
      pagekey: undefined
    };
  },
  watch: {
    $route(val, old) {
      let _key;
      switch (val.name) {
        case "diy_page":
        case "pageH5":
          _key = val.params.id || val.query.id;
          break;
      }
      this.pagekey = _key;
    }
  },
  computed: {
    ...mapGetters(["direction"]),
    // 动画方向
    directionClass() {
      return this.direction === "forward" ? "mint-pop-in" : "mint-pop-out";
    },
    hasNav() {
      return this.$route.meta.showBar;
    },
    includeList() {
      console.log("keepList", this.keepList.join(","));
      return this.keepList.join(",");
    }
  },
  created() {},
  components: {
    tabBar
  },
  methods: {}
};
</script>
<style lang="scss">
@import "./styles/index.scss";
html,
body,
.app {
  height: 100%;
  width: 100%;
}
body * {
  box-sizing: border-box;
}
.app {
  overflow: hidden;
  height: 100%;
  min-height: 0px;
  display: flex;
  flex-direction: column;
  .app-body {
    flex: 1;
    overflow: hidden;
    min-height: 0px;
  }
  .app-tab {
    // flex: 0;
    &.van-tabbar--fixed {
      &::after {
        content: none;
      }
      position: relative;
    }
  }
}
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  #app {
    padding-bottom: env(safe-area-inset-bottom);
    // &.has-footer {
    //   padding-bottom: calc(50px + env(safe-area-inset-bottom));
    //   .van-tabbar--fixed {
    //     bottom: env(safe-area-inset-bottom);
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue